/* NC Teppich nach Maß – Preislogik (rein, ohne DOM, testbar)
 * Regeln (von Sebastian bestätigt 23.09.2026):
 *  - 650 € pro m², kein Mindestpreis, keine Stufen
 *  - Rund wird als umschließendes Quadrat berechnet: Ø × Ø
 *  - Mindestmaß 100 cm pro Seite
 * Modi:
 *  - "quantity": Preis-Einheit = 1 dm² (100 cm²). Menge = gerundete dm², Stückpreis = Variantenpreis.
 *                Angezeigter Preis = Menge × Stückpreis = exakt der Checkout-Preis.
 *  - "function": Menge 1, Preis wird serverseitig gesetzt: round(cm² × Preis_pro_m² / 10000).
 */
(function (root) {
  function areaCm2(shape, w, l, d) {
    return shape === 'round' ? d * d : w * l;
  }

  function calc(opts) {
    var cm2 = areaCm2(opts.shape, opts.w, opts.l, opts.d);
    var res = { cm2: cm2 };
    if (opts.mode === 'function') {
      res.quantity = 1;
      res.totalCents = Math.round(cm2 * opts.pricePerSqmCents / 10000);
      res.m2 = cm2 / 10000;
    } else {
      var units = Math.round(cm2 / 100); // dm², kaufmännisch gerundet (x,5 -> auf)
      res.quantity = units;
      res.totalCents = units * opts.unitPriceCents;
      res.m2 = units / 100; // exakt die abgerechnete Fläche
    }
    return res;
  }

  function validate(v, min, max) {
    if (v === '' || v === null || v === undefined) return 'empty';
    var n = Number(v);
    if (!isFinite(n)) return 'nan';
    if (Math.floor(n) !== n) return 'int';
    if (n < min) return 'min';
    if (n > max) return 'max';
    return null;
  }

  var api = { areaCm2: areaCm2, calc: calc, validate: validate };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.NcTnmPrice = api;
})(typeof window !== 'undefined' ? window : globalThis);
